type AnimatedBarProps = {
  label: string;
  value: string;
  /** Bar fill percentage (0–100) */
  percent: number;
  /** CSS background-color for the bar fill */
  color?: string;
  /** Whether to use Tailwind `bg-primary` instead of inline color */
  usePrimaryColor?: boolean;
  /** Tailwind width class for the label column (e.g. 'w-24', 'w-28') */
  labelWidth?: string;
  /** Tailwind width class for the value column (e.g. 'w-8', 'w-12') */
  valueWidth?: string;
  /** Whether the entrance animation has triggered */
  animated: boolean;
  /** Stagger index for transition delay */
  index: number;
};

export default function AnimatedBar({
  label,
  value,
  percent,
  color,
  usePrimaryColor = false,
  labelWidth = 'w-24',
  valueWidth = 'w-8',
  animated,
  index,
}: AnimatedBarProps) {
  return (
    <div className="flex items-center gap-3" role="listitem">
      <span
        className={`${labelWidth} shrink-0 truncate text-right text-sm text-neutral-600 dark:text-neutral-300`}
      >
        {label}
      </span>
      <div className="h-7 flex-1 overflow-hidden rounded-full bg-neutral-100 dark:bg-neutral-700/40">
        <div
          className={`h-full rounded-full transition-all duration-700 ease-out${
            usePrimaryColor ? ' bg-primary' : ''
          }`}
          style={{
            width: animated ? `${percent}%` : '0%',
            ...(color && !usePrimaryColor ? { backgroundColor: color } : {}),
            transitionDelay: `${index * 60}ms`,
          }}
        />
      </div>
      <span
        className={`${valueWidth} shrink-0 text-right text-sm font-medium tabular-nums text-neutral-700 dark:text-neutral-300`}
      >
        {value}
      </span>
    </div>
  );
}
